<div class="container">
  <div class="row">
    <div class="col-7 mt-3 mb-5 py-5 mx-auto">

      <div class="mb-3">
        <h1>Please confirm your email address.</h1>
        <p>We sent an email with a confirmation link to the the address you provided.
          Please check your inbox and click the link to confirm your identity.</p>
        <span><a class="resend-link" (click)="resendVerificationEmail()">Resend Verification Email</a></span>
      </div>

      <div *ngIf="resendEmailAlertShown" [@openSuccessAlert]>
        <div class="alert alert-success mb-4 py-3" role="alert">
          <p>We have re-sent the confirmation email to the address you provided. Please check your inbox. <br>
            <br> Still not receiving any email? Please check your SPAM mail folder. If you're still having issues, please contact us at {{ customerServicePhone }}.</p>
        </div>
      </div>

    </div>
  </div>
</div>
